import { fromBech32m, toBech32m } from './format/convert.js';
import { Inner } from './format/inner.js';
import { Prefixes } from './format/prefix.js';
const innerName = Inner.penumbra;
const prefix = Prefixes.penumbra;
export const bech32mAddress = ({ [innerName]: bytes }) => toBech32m(bytes, prefix);
export const addressFromBech32m = (penumbra1) => ({
    [innerName]: fromBech32m(penumbra1, prefix),
});
export const isAddress = (check) => {
    try {
        addressFromBech32m(check);
        return true;
    }
    catch {
        return false;
    }
};
export { PENUMBRA_BECH32M_ADDRESS_LENGTH, PENUMBRA_BECH32M_ADDRESS_PREFIX } from './index.js';
